export default __webpack_public_path__ + "static/media/picred.d5b3bd88.png";